import React, { useEffect, useState, useContext } from "react";
import { Col, Row, Button } from "react-bootstrap";
import { getCDNImage } from "../../globals";
import { currencyFormat, i18nValue, getAvailableHours, priceWithoutTax } from "../../functions";
import { T, TF } from "react-translator-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus, faThumbsUp } from "@fortawesome/free-solid-svg-icons";
import { RoomService } from "../Icons";
import processHtml from "../processHtml";
import { hotelShowsPriceWithoutTaxes } from "../../components/CheckIn/hotelConditions";
import { HotelContext } from "../../context/hotel";

const CartItem = ({ key, item, value, language, showImages, showCustomizationMessages, currency, handleAddButtonClick, handleDeleteItem, cartAvailavility = true, hideOnDisabled = false }) => {
    const [enabledHours, setEnabledHours] = useState([]);
    const [disabled, setDisabled] = useState(false);
    const [hidden, setHidden] = useState(false);
    const { data: hotel } = useContext(HotelContext);
    let hasTaxes = hotelShowsPriceWithoutTaxes(hotel.id);
    
    useEffect(() => {

        if (item.disableTimeRanges) {
            const disabledByHour = getAvailableHours(item.disableTimeRanges);
            setEnabledHours(disabledByHour.ranges);
            setDisabled(disabledByHour.isDisabled);
            setHidden(hideOnDisabled && disabledByHour.isDisabled);
        }

    }, []);

    return (
        <>
            {hidden && (
                <div className="cart-no-item" key={key}></div>
            )}

            {!hidden && (<div className="cart-item" key={key} style={{ color: `${disabled && '#BBB'}` }}>
                <Row className="justify-content-center align-items-start general-text-xs">
                    {/* Primera columna: Ancho fijo */}
                    <Col xs="auto" className="pl-1 pr-0">
                        <div style={{ opacity: `${disabled && '0.7'}` }}>
                            {showImages && (
                                <>
                                    {item.photo && (
                                        <img
                                            src={getCDNImage(item.photo)}
                                            className="service-item-photo"
                                            alt={item.name}
                                        />
                                    )}
                                    {!item.photo && (
                                        <div className="service-item-photo" style={{ textAlign: "center", paddingTop: 20 }}>
                                            <RoomService width={50} height={50} />
                                        </div>
                                        // <img
                                        //     src={"/logo_57.png"}
                                        //     className="service-item-photo no-photo"
                                        //     alt={item.name}
                                        // />
                                    )}
                                </>
                            )}
                        </div>
                    </Col>

                    {/* Columna central: Flexible */}
                    <Col className="flex-grow-1 p-0">
                        <div className="px-2 overflow-hidden">

                            <h6 className="text-uppercase mb-0 pb-0">
                                <b>{i18nValue(item, "name", language, null, item.name)}</b>
                            </h6>
                            <p className="service-full-item-description mb-0"
                                style={{
                                    fontSize: "0.7rem"
                                }}>
                                {processHtml(i18nValue(item, "description", language, null, item.description))}
                            </p>

                            <div className="d-flex justify-content-between align-items-center pt-2" style={{ height: 40 }}>

                                <div>
                                    {item.price > 0 && (
                                        <div className="d-flex justify-content-start align-items-start flex-column">
                                            <span className="general-text" style={{ marginTop: "py-1" }}>
                                                <b>{currencyFormat(item.price, currency)}</b>
                                            </span>
                                        </div>
                                    )}
                                    {!item.price && (
                                        <span className="general-text text-success" >
                                            <b>{T("general.no-charge")}</b>
                                        </span>
                                    )}
                                </div>

                                {!disabled && cartAvailavility && (
                                    <div>
                                        {(value <= 0) && (
                                            <div className="mb-1">
                                                <Button
                                                    value={item.code}
                                                    onClick={() => handleAddButtonClick(item.id)}
                                                    className={"nud-center"}
                                                >
                                                    <FontAwesomeIcon className="nud-icon" icon={faPlus} />
                                                </Button>
                                            </div>
                                        )}

                                        {(value > 0) && (
                                            <div className="mb-1">
                                                <Button
                                                    value={item.id}
                                                    onClick={() => handleDeleteItem(item.id)}
                                                    className={"nud-left"}
                                                >
                                                    <FontAwesomeIcon className="nud-icon" icon={faMinus} />
                                                </Button>
                                                <input
                                                    id={item.id}
                                                    className="nud-number"
                                                    min={0}
                                                    type={"text"}
                                                    readOnly={true}
                                                    value={value}
                                                ></input>
                                                <Button
                                                    value={item.code}
                                                    onClick={() => handleAddButtonClick(item.id)}
                                                    className={"nud-right"}
                                                >
                                                    <FontAwesomeIcon className="nud-icon" icon={faPlus} />
                                                </Button>

                                            </div>
                                        )}
                                    </div>
                                )}

                            </div>
                            {hasTaxes && item?.price > 0 && (
                                <span className="general-text" style={{ marginTop: "py-1", fontSize: "0.7rem", color: "#5a5a5a" }}>
                                    {T("menu.price_without_taxes")}: {currencyFormat(priceWithoutTax(item.price), currency)}
                                </span>
                            )}
                        </div>
                    </Col>
                </Row>

                <Row className="mb-1">
                    <Col>
                        {item.preferences && Object.keys(item.preferences).length > 0 && showCustomizationMessages[item.id] && (
                            <div className="general-text text-center mt-2" style={{ color: "#e88b01", zIndex: 0, fontSize: "12px" }}>
                                <b>{T('request.customize_next')}</b>
                            </div>
                        )}

                        {disabled && (
                            <div className="general-text text-center mt-2" style={{ color: "#F00", zIndex: 0, fontSize: "12px", marginLeft: "auto", marginRight: "auto" }}>
                                <div className="d-flex justify-content-center align-items-center">
                                    <b>{T('request.item-out-of-hours')}</b>
                                    {/* {enabledHours?.map((el, idx) => (
                                        <span key={`hor-dis-${idx}`} className="general-text-sm pl-1">
                                            <b>{TF("request.available-time-from-to", el[0], el[1])}</b>
                                        </span>
                                    ))} */}
                                </div>
                            </div>
                        )}
                    </Col>
                </Row>
            </div>)}
        </>
    )
}

export default CartItem;